import React, { useContext, useEffect } from 'react'
import styles from '../styles.module.css'
import Table from '../../../components/Table'
import { useDispatch, useSelector } from 'react-redux'
import { getAbsences } from '../../../actions/classbook'
import { ClassbookContext } from '../../../utils/context'

export default function Absences() {
  const dispatch = useDispatch()

  const { formData } = useContext(ClassbookContext)

  const { absences } = useSelector(state => state.classbook)

  useEffect(() => {
    const { studyPeriod: trmid, class: gid } = formData
    trmid && gid && dispatch(getAbsences(trmid, gid))
  }, [formData])

  // ПУСТОЙ ПРИХОДИТ
  const renderLi = (data) => {
    const { fio, gr, kolvo_days } = data
    return (
      <tr >
        <td>{fio}</td>
        <td>{kolvo_days}</td>
        <td>{gr}</td>
      </tr>
    )
  }

  return (
    <div >
      <Table className={styles.tables}>
        <thead>
          <tr>
            <th>Ученица</th>
            <th>Количество дней</th>
            <th>Количество уроков</th>
          </tr>
        </thead>
        <tbody>
          {absences?.map(renderLi)}
        </tbody>
      </Table>
    </div>
  )
}
